import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'list-items',
  templateUrl: './list-items.component.html'
})
export class ListItemsComponent implements OnInit {

  @Input() table_id: string;
  @Input() data;
  @Output() out: EventEmitter<any>;

  public identity;

  constructor() {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.out = new EventEmitter;
  }

  ngOnInit() {
    // console.log(this.table_id);
    console.log(this.data);
  }

  saveEmit(accion, id, item = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      item: item
    };
    this.out.emit(send);
  }

}